import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import ProfesionesView from './ProfesionesView';
import * as ROUTES from '../../../router/Routes';

const ProfesionesModule = () => {
  return (
    <ContainerTemplate active={ROUTES.profesiones} routes={[]}>
      <ProfesionesView />
    </ContainerTemplate>
  );
};

export default ProfesionesModule;
